<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'

    import { fly } from 'svelte/transition'

    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1"

    let y_value;

    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }

    import { nightmode } from "../stores5.js"
</script>

<div class:night={$nightmode} style="padding-left:8px; z-index:-2;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: -200}}">共鳴</div>
        <div class="catch-item2" transition:fly="{{x: 200}}">共鳴</div>
        <div class="catch-img" class:catch-img-night={$nightmode} transition:fly="{{x: 200}}"></div>
        <svg xmlns="http://www.w3.org/2000/svg">
            <filter id="filter">
                <feColorMatrix
                  type="matrix"
                  values=" 1.200  0.200  0.000  0.000  0.000 
                           0.000  1.000  0.000  0.000  0.300 
                           0.000  0.000  0.300  0.000  0.100 
                           0.000  0.000  0.000  1.000  0.000">
                </feColorMatrix>
            </filter>
        </svg>
    </div>
    <div class="date" class:date-night={$nightmode} transition:fly="{{x: -200}}">
        <div class="date-item1">
            2021.09.18 - 19
        </div>
        <div class="date-item2">10am - 5pm / Sta - Sun</div>
        <div class="date-item3">都立西高校</div>
        <p style="font-size:20px; font-weight:700; padding:0; margin-left:2%; margin:40px 0; width:85%;">校内のみでの開催でしたが無事終了しました。<br><a href="https://kinensai-online.vercel.app">記念祭オンライン</a>を期間限定で開催中なので、ぜひ御覧下さい。</p>
    </div>
    <div class="detail top-contents" class:top-contents-night={$nightmode} transition:fly="{{x: -200}}" on:click={() => push('/base2')}>
        <div class="detail-img"></div>
        <div class="detail-title top-contents-title" class:top-contents-title-night={$nightmode}>開催概要</div>
        <div class="detail-summary top-contents-summary" class:top-contents-summary-night={$nightmode}>
            <p>開催に関する詳細はこちら。</p>
        </div>
        <div class="arrow1"></div>
    </div>
    <div class="introduction top-contents" class:top-contents-night={$nightmode} transition:fly="{{x: -200}}" on:click={() => push('/base3')}>
        <div class="introduction-img"></div>
        <div class="introduction-title top-contents-title" class:top-contents-title-night={$nightmode}>団体紹介/予約</div>
        <div class="introduction-summary top-contents-summary" class:top-contents-summary-night={$nightmode}>
            <p>記念祭に参加する団体を</p>
            <p>紹介します。</p>
            <p>各団体のページから</p>
            <p>予約が可能です。</p>
        </div>
        <div class="arrow1"></div>
    </div>
    <div class="concept top-contents" class:top-contents-night={$nightmode} transition:fly="{{x: -200}}" on:click={() => push('/base4')}>
        <div class="concept-img"></div>
        <div class="concept-title top-contents-title" class:top-contents-title-night={$nightmode}>共鳴</div>
        <div class="concept-summary top-contents-summary" class:top-contents-summary-night={$nightmode}>
            <p>今年の記念祭テーマは</p>
            <p>「共鳴」</p>
            <p>に決定しました。</p>
        </div>
        <div class="arrow1"></div>
    </div>
    <footer class="footer" transition:fly="{{x: -200}}">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>
{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}

<svelte:window bind:scrollY={y_value}/>

<style>
a{
    color:black;
    text-decoration:underline greenyellow;
}
a:visited{
    color:black;
}
a:hover{
    color:greenyellow;
}
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin:16px 0 16px 0;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    width:100%;
    height:580px;
    position:relative;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    left:-40px;
    font-size:200px;
    font-weight:400;
    letter-spacing: 0.3em;
    font-family: "游明朝" , "Yu Mincho" , "游明朝体" , "YuMincho" , "ヒラギノ明朝 Pro W3" , "Hiragino Mincho Pro",serif;
    -ms-writing-mode: vertical-rl;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    position:absolute;
    text-indent: 0.3em;
    z-index:2;
}
.catch-item2{
    position:absolute;
    right:-160px;
    font-size:200px;
    font-weight:400;
    letter-spacing: 0.3em;
    font-family: 'Noto Serif JP', serif;
    -ms-writing-mode: vertical-rl;
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-indent: 0.3em;
    z-index:2;
}
.catch-img{
    position:absolute;
    top:40px;
    right:-10px;
    width:80%;
    height:500px;
    z-index: 1;
    background-image: url(/img/kinensai-pic-1-color.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    filter:url(#filter);
    border-radius: 20px;
}
.catch-img-night{
    background-image:url(/img/kinensai-pic-1-color__fliter.png);
    filter:none !important;
}
.date{
    margin-bottom:30px;
    padding-left:2%;
}
.date-night{
    color:#000000;
}
.date-item1{
    display: table;
    font-size:40px;
    font-weight: 300;
    letter-spacing: 0.02em;
    padding-bottom:5px;
    background-color: greenyellow;
}
.date-item2{
    display:table;
    font-size:24px;
    font-weight: 400;
    letter-spacing: 0.02em;
    padding-bottom:8px;
    background-color: greenyellow;
}
.date-item3{
    display:table;
    font-size:36px;
    font-weight: 300;
    letter-spacing: 0.02em;
    background-color: greenyellow;
}
.top-contents{
    position:relative;
    padding:30px 10px 30px 0;
    margin: 2%;
    width:85%;
    height:170px;
    border-top: 1px solid;
    border-color: black;
    z-index: 3;
    cursor: pointer;
}
.top-contents-night{
    border-color: #dddddd;
}
.top-contents-title-night{
    color:#000000 !important;
}
.top-contents-summary-night p{
    color:#000000 !important;
}
.top-contents-title{
    display: table;
    font-size:30px;
    margin-bottom:15px;
    z-index: 3;
    background-color: greenyellow;
}
.top-contents-summary{
    width:80%;
    margin:40px 20px 10px 0;
    z-index: 3;
}
.top-contents-summary p{
    font-size:16px;
    padding:5px 0 5px 0;
    z-index: 3;
    display: table;
    -webkit-backdrop-filter: blur(5px);
    background-color: rgb(173, 255, 47,.7);
    backdrop-filter:blur(5px);
}
.introduction-img{
    position:absolute;
    top:40px;
    right:40px;
    width:80%;
    height:140px;
    z-index: -1;
    background-image:linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(/img/kinensai-pic-1.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 30%;
}
.detail-img{
    position:absolute;
    top:40px;
    right:40px;
    width:80%;
    height:140px;
    z-index: -1;
    background-image:linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(/img/kinensai-pic-2.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position:50% 50%;
}
.detail-summary{
    margin-top:90px;
}
.concept-img{
    position:absolute;
    top:40px;
    right:40px;
    width:80%;
    height:140px;
    z-index: -1;
    background-image:linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(/img/kinensai-pic-8.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position:50% 40%;
}
.concept-summary{
    margin-top:40px;
}
.arrow1{
    position:absolute;
    bottom:15px;
    right:40px;
    width: 10px;
    height: 10px;
    border-top: solid 1px #000000;
    border-right: solid 1px #000000;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
.footer{
    padding:40px 0 40px 0;
    width:85%;
    margin-left:2%;
    border-top: 1px solid;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
@media screen and (min-width:768px){
    .top-contents{
        height:340px;
    }
    .introduction-img{
        height:300px;
        width:70%;
        left:200px;
    }
    .detail-img{
        height:300px;
        width:70%;
        left:200px;
    }
    .concept-img{
        height:300px;
        width:70%;
        left:200px;
    }
    .introduction-summary{
        margin-top:160px;
    }
    .detail-summary{
        margin-top:250px;
    }
    .concept-summary{
        margin-top:190px;
    }
    .top-contents-title{
        font-size:40px;
    }
    .top-contents-summary p{
        font-size:22px;
    }
    .arrow1{
        bottom:25px;
        right:100px;
    }
}
</style>